import { useState } from 'react';
import useCreateRow from './useCreateRow';
import CreateRowButton from './CreateRowButton';
import Prompt from '@/components/Prompt';
import Dialog from '@/components/Dialog';
import { FormattedMessage } from 'react-intl';
import FormattedMessageWithChallengeNaming from '@/components/FormattedMessageWithChallengeNaming';

const CreateRow = () => {
  const [rowPromptOpen, setRowPromptOpen] = useState(false);

  const createRow = useCreateRow();

  const saveNewRow = (name: string) => {
    setRowPromptOpen(false);

    createRow(name);
  };

  return (
    <>
      <CreateRowButton onClick={() => setRowPromptOpen(true)} />
      <Prompt
        open={rowPromptOpen}
        onOk={saveNewRow}
        OkButton={Dialog.Actions.CreateButton}
        onCancel={() => setRowPromptOpen(false)}
        emptyError="prompt.errors.name_empty"
      >
        <Dialog.Title>
          <FormattedMessage id="portfolio.create_row.title" />
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessageWithChallengeNaming id="portfolio.create_row.text" />
          </Dialog.ContentText>
        </Dialog.Content>
        <Prompt.TextField
          label={<FormattedMessage id="portfolio.create_row.input_label" />}
        />
      </Prompt>
    </>
  );
};

export default CreateRow;
